import { Rule } from '../components/Rule';

export function NotFound() {
  return (
    <main class="lost">
      <span class="eyebrow">Off the map</span>
      <h1>This page has drifted</h1>
      <Rule short />
      <p class="prose" style={{ marginInline: 'auto' }}>
        Nothing lives at this address. The tide will carry you back.
      </p>
      <a class="btn" href="/" style={{ justifySelf: 'center' }}>
        Return home
      </a>
    </main>
  );
}
